import DatePanel from './date-panel';

export default DatePanel;
